import { Box, HStack, Text } from '@chakra-ui/react';
import { InsuranceAuthorization } from '@web-app/graphql/healthie/queries/get-client-insurance-details/types';

type Props = {
  data: InsuranceAuthorization;
};

export const VisitsUsed = ({
  data: { visitsUsed, visitsAuthorized, isUnlimitedVisits },
}: Props) => (
  <HStack justifyContent="space-between" width="100%">
    <HStack gap={1} alignItems="center">
      <Box
        backgroundColor="success.700"
        width="14px"
        height="14px"
        borderRadius={200}
      />
      <Text>{visitsUsed} visits used</Text>
    </HStack>

    <Text>
      {isUnlimitedVisits ? 'Unlimited' : visitsAuthorized} visits covered
    </Text>
  </HStack>
);
